import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  const megaPackUrl = 'https://checkout.guiadigital360.online/cart/43889650401349:1';
  const aceleradorUrl = 'https://checkout.guiadigital360.online/cart/44773397397573:1';
  return <section id="compra" className="py-24 px-4 bg-brand-light scroll-mt-10" data-id="element-224">
      <div className="max-w-5xl mx-auto" data-id="element-225">
        <div className="text-center mb-16" data-id="element-226">
          <h2 className="text-5xl font-black text-brand-dark mb-4" data-id="element-227">
            Elegí tu Arsenal:
          </h2>
          <p className="text-2xl font-bold text-brand-rust" data-id="element-228">
            Ambas opciones incluyen los 3 bonos de regalo
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center mb-16 max-w-4xl mx-auto" data-id="element-229">
          {/* Card 1: Mega Pack */}
          <div className="bg-white rounded-3xl p-8 shadow-lg border border-gray-200 flex flex-col h-full" data-id="element-230">
            <div className="text-5xl mb-4" data-id="element-231">📘</div>
            <h3 className="text-2xl font-black text-brand-dark mb-2" data-id="element-232">
              MEGA PACK COMPLETO
            </h3>
            <p className="text-xl font-bold text-gray-700 mb-2" data-id="element-233">
              Los 5 Tomos Maestros
            </p>
            <p className="text-gray-600 mb-1" data-id="element-234">Todo el sistema paso a paso</p>
            <p className="text-gray-600 mb-1" data-id="element-235">+ Los 3 Bonos Exclusivos</p>
            <p className="text-gray-600 mb-1" data-id="element-236">
              + 🏋️{' '}
              <span className="font-bold text-brand-dark" data-id="element-237">
                BONO EXTRA: Planos de Máquinas de Gym
              </span>
            </p>
            <p className="text-gray-500 text-sm mb-8" data-id="element-238">
              Estructuras metálicas y mobiliario de alto rendimiento para
              gimnasios
            </p>

            <div className="mt-auto" data-id="element-239">
              <div className="text-gray-400 text-xl line-through font-bold mb-1" data-id="element-240">
                $81.930
              </div>
              <div className="text-4xl font-black text-brand-amber mb-8" data-id="element-241">
                $19.990 ARS
              </div>
              <CTAButton text="→ QUIERO EL MEGA PACK" href={megaPackUrl} isLink={true} className="text-lg py-3" data-id="element-242" />
            </div>
          </div>

          {/* Card 2: Con Acelerador (Highlighted) */}
          <div className="bg-white rounded-3xl p-8 shadow-2xl border-4 border-brand-amber relative transform md:scale-105 z-10 flex flex-col h-full" data-id="element-243">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-brand-amber text-white font-black px-6 py-2 rounded-full text-sm tracking-widest shadow-md whitespace-nowrap" data-id="element-244">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="text-5xl mb-4 text-center mt-4" data-id="element-245">⚡</div>
            <h3 className="text-3xl font-black text-brand-dark mb-2 text-center" data-id="element-246">
              MEGA PACK
              <br data-id="element-247" />+ ACELERADOR 24HS
            </h3>

            <div className="bg-green-100 text-green-800 font-bold text-center py-2 rounded-lg mb-4" data-id="element-248">
              TU PRIMERA VENTA EN 30 DÍAS
            </div>

            <p className="text-lg font-bold text-gray-800 text-center mb-2" data-id="element-249">
              Todo el Mega Pack + El mapa exacto de 30 días
            </p>
            <p className="text-gray-600 text-center mb-2 font-medium text-sm" data-id="element-250">
              Incluye Calculadora de Precios, Plan de Acción Diario y Guiones
              para el Corralón.
            </p>
            <p className="text-brand-dark text-center mb-8 font-black text-lg" data-id="element-251">
              + de 700 planos listos para fabricar
            </p>

            <div className="mt-auto text-center" data-id="element-252">
              <div className="text-gray-400 text-2xl line-through font-bold mb-1" data-id="element-253">
                $99.900
              </div>
              <div className="text-5xl font-black text-brand-amber mb-8" data-id="element-254">
                $24.990 ARS
              </div>
              <CTAButton text="→ SÍ, QUIERO EL ACELERADOR" href={aceleradorUrl} isLink={true} className="text-xl py-4" data-id="element-255" />
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 text-sm md:text-base text-gray-600 font-bold bg-white py-6 px-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-256">
          <span className="flex items-center gap-2" data-id="element-257">
            <LockIcon className="w-6 h-6 text-gray-500" data-id="element-258" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-259">
            <ZapIcon className="w-6 h-6 text-brand-forge" data-id="element-260" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-261">
            <ShieldCheckIcon className="w-6 h-6 text-brand-green" data-id="element-262" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-2" data-id="element-263">
            <CreditCardIcon className="w-6 h-6 text-brand-steel" data-id="element-264" /> Mercado Pago
            · Tarjeta · Transferencia
          </span>
        </div>
      </div>
    </section>;
}